import React from "react";

const handleOnlinePayments = (props) => {
  const options = [
    {
      text: 'Ma transaction d\'INTERAC en ligne me préoccupe. Pouvez-vous m’aider?',
      handler: props.actionProvider.handleOnlinePayments1,
      id: 1,
    },
    {
      text: 'Y a-t-il des limites quant au montant que je peux dépenser à l’aide d’INTERAC en ligne?',
      handler: props.actionProvider.handleOnlinePayments2,
      id: 2
    },
    {
      text: 'Combien coûte l’utilisation d’INTERAC en ligne?',
      handler: props.actionProvider.handleOnlinePayments3,
      id: 3
    },
    {
      text: 'Que se passe-t-il si je n\'utilise pas les services bancaires en ligne ?',
      handler: props.actionProvider.handleOnlinePayments4,
      id: 4
    },
    {
      text: 'À qui dois-je m’adresser en cas de problème lorsque j’utilise INTERAC en ligne?',
      handler: props.actionProvider.handleOnlinePayments5,
      id: 5
    },
    {
      text: 'Comment savoir si mon paiement en ligne a été traité?',
      handler: props.actionProvider.handleOnlinePayments5,
      id: 6
    },
  ];

  const optionsMarkup = options.map((option) => (
    <label key={option.text.replace(/\s+/g, '-').toLowerCase()}>
    <input
      type="radio"
      className='consumer-product-button'
      value={option.id}
      name="consumer"
      onClick={option.handler}
    />
    
    <span className={option.text.replace(/\s+/g, '-').toLowerCase()}>{option.text}</span>
      </label>
  ));

  return <div className='consumer-products-container requestmoney-products'>{optionsMarkup}</div>;
};

export default handleOnlinePayments;